export default {
  formActions: {
    'addPlaceInput': 'Aggiungi luogo',
    'clearRoute': 'Cancella itinerario',
    'reverseRoute': 'Inverti itinerario',
    'roundTrip': 'Andata e ritorno',
    'toggleRoundTrip': 'Attiva/Disattiva funzione andata e ritorno',
    'showDangerousAreas': 'Aree pericolose'
  }
}
